var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationFilled = function SvgLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.459 5.425C14.625 3.675 13.034 2.4 11.192 2a5.574 5.574 0 0 0-1.175-.125 6.097 6.097 0 0 0-5.942 4.817c-.55 2.625.85 4.833 2.092 6.775.292.45.575.9.833 1.35l1.359 2.35c.35.6.966.958 1.658.958a1.89 1.89 0 0 0 1.658-.958l1.808-3.134c.209-.358.425-.708.642-1.058.65-1.05 1.325-2.133 1.7-3.375.409-1.358.284-2.842-.358-4.175h-.008Zm-5.45 5.608a2.92 2.92 0 0 1-2.917-2.916A2.92 2.92 0 0 1 10.009 5.2a2.92 2.92 0 0 1 2.916 2.917 2.92 2.92 0 0 1-2.917 2.916Z",
    fill: "current"
  })));
};
export default SvgLocationFilled;